import { render, staticRenderFns } from "./InvestigationAdd.vue?vue&type=template&id=382d1df5"
import script from "./InvestigationAdd.vue?vue&type=script&lang=js"
export * from "./InvestigationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports